export default "__VITE_ASSET__25kiA5_i__"